/**
 * PreferenciasSom — toggle "Som de notificação" (por dispositivo).
 *
 * Spec: docs/superpowers/specs/2026-07-09-chat-notification-sound-design.md §4.
 *
 * Preferência local (localStorage `consoleai.sound.enabled`, default ON), sem
 * backend/migration. Toca uma prévia ao ligar para o usuário conferir o timbre.
 * Segue o padrão WidgetCard das demais preferências.
 */
import { Stack, Group, ThemeIcon, Text, Switch } from '@mantine/core'
import { IconVolume } from '@tabler/icons-react'
import { useState } from 'react'
import { WidgetCard } from '@/components/ui'
import {
  getSoundEnabled,
  setSoundEnabled,
  playSound,
} from '@/lib/notificationSound'

export function PreferenciasSom() {
  const [enabled, setEnabled] = useState(() => getSoundEnabled())

  const onToggle = (next: boolean) => {
    setEnabled(next)
    setSoundEnabled(next)
    // Prévia ao ligar — o gesto do clique também desbloqueia o áudio.
    if (next) playSound('message')
  }

  return (
    <WidgetCard p="md">
      <Stack gap="sm">
        <Group gap={8} align="center">
          <ThemeIcon size={32} radius="md" color="grape" variant="light">
            <IconVolume size={18} />
          </ThemeIcon>
          <Text fw={600} size="sm">Som de notificação</Text>
        </Group>

        <Text size="xs" c="dimmed">
          Toca um som curto com identidade ConsoleAI (distinto por tipo e
          severidade) ao chegar mensagem ou alerta no chat com o app aberto.
          Preferência por dispositivo — o push do sistema cobre o app fechado.
        </Text>

        <Switch
          checked={enabled}
          onChange={(e) => onToggle(e.currentTarget.checked)}
          label={enabled ? 'Ativado' : 'Desativado'}
        />
      </Stack>
    </WidgetCard>
  )
}
